<template>
  <div class="content_box">
    <div style="text-align: center">
      <img src="../assets/success.png" style="width: 20%"/>
    </div>
    <h4 style="margin:0;margin-bottom:0.5rem;text-align: center;width: 100%;color: #0cb956;font-weight: 900">预约成功</h4>
    <div class="content" v-html="content">
    </div>
  </div>
</template>

<script>
  export default {
    name: "process",
    data() {
      return {
        content: ''
      }
    },
    async mounted() {
      this.loadData()
    },
    methods: {
      loadData() {
        let _this = this;
        _this.$http.post('/client/process', {tp: 'process'}).then(function (response) {
          console.log(response)
          _this.content = response.data.data.content
        }).catch(function (error) {
          console.log(error);
        })
      }
    }
  }
</script>

<style>
  .content {
    width: 100%;
    border: 2px solid #0cb956;
    border-radius: 0.5rem;
    overflow: hidden;
    box-sizing: border-box;
    padding: 1rem;
    font-size: 0.85rem;
    color: #666;
  }

  .content img {
    max-width: 100%;
    margin: 0 auto;
  }

  .content_box {
    width: 96%;
    margin: 2%;
    box-sizing: border-box;
  }

  .process_box {
    border: 1px solid #0cb956;
    background: #f7fedf;
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    text-align: center;
    border-radius: 5px;
    font-weight: 900;
    font-size: 1rem;
  }

  .next_img {
    width: 100%;
    text-align: center;
  }

  .next_img img {
    width: 20px;
  }

  p {
    line-height: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/process.vue